var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "@drklein/locale-formatter", "jquery"], function (require, exports, LocaleFormatter) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.initialize = void 0;
    LocaleFormatter = __importStar(LocaleFormatter);
    var nettohaushaltseinkommenMinimum = 476;
    var budgetFactor = 90.62414826928318;
    var angebotFactor = 105;
    var angebotBetragDefault = 315000;
    function getNettohaushaltseinkommen($nettohaushaltseinkommenInput) {
        return parseInt($nettohaushaltseinkommenInput.val().toString().replace(/\D/g, ""), 10);
    }
    function updateAngebotParameters($nettohaushaltseinkommenInput, $ratenkreditLinkElement, $finanzierungsvorschlaegeLinkElement, budgetKurzrechnerConfiguration) {
        var nettohaushaltseinkommen = getNettohaushaltseinkommen($nettohaushaltseinkommenInput);
        if (nettohaushaltseinkommen > budgetKurzrechnerConfiguration.nettohaushaltseinkommenMaximum) {
            nettohaushaltseinkommen = budgetKurzrechnerConfiguration.nettohaushaltseinkommenDefault;
        }
        var angebotBetrag;
        if (Number.isNaN(nettohaushaltseinkommen)) {
            angebotBetrag = angebotBetragDefault;
        }
        else {
            angebotBetrag = nettohaushaltseinkommen * angebotFactor;
        }
        $ratenkreditLinkElement.attr("href", budgetKurzrechnerConfiguration.ratenkreditLinkUrl + "?kreditbetrag=" + angebotBetrag);
        $finanzierungsvorschlaegeLinkElement.attr("href", budgetKurzrechnerConfiguration.finanzierungsvorschlaegeLinkUrl + "?darlehensbetrag=" + angebotBetrag);
    }
    function updateBudget(nettohaushaltseinkommen, $nettohaushaltseinkommenInput) {
        var $budgetKurzrechner = $nettohaushaltseinkommenInput.parents(".budgetKurzrechner");
        var $budgetArea = $budgetKurzrechner.find(".budgetKurzrechner_budget");
        var $nettohaushaltseinkommenInputFirst = $nettohaushaltseinkommenInput.get(0) || null;
        if ($nettohaushaltseinkommenInputFirst !== null) {
            if ($nettohaushaltseinkommenInputFirst.validity.valid) {
                var budget = Math.round(nettohaushaltseinkommen * budgetFactor);
                $budgetKurzrechner
                    .find(".budgetKurzrechner_budgetBetrag")
                    .text(LocaleFormatter.currency(budget));
                $budgetArea.show();
            }
            else {
                $budgetArea.hide();
            }
        }
        else {
            $budgetArea.hide();
        }
    }
    function showRelevantResultSegment(nettohaushaltseinkommen, $budgetKurzrechner) {
        if (nettohaushaltseinkommen <= nettohaushaltseinkommenMinimum) {
            $budgetKurzrechner.find(".budgetKurzrechner_budgetResult").hide();
            $budgetKurzrechner.find(".budgetKurzrechner_ratenkreditResult").show();
        }
        else {
            $budgetKurzrechner.find(".budgetKurzrechner_ratenkreditResult").hide();
            $budgetKurzrechner.find(".budgetKurzrechner_budgetResult").show();
        }
    }
    function addSubmitHandler($budgetKurzrechner, $nettohaushaltseinkommenInput, $ratenkreditLinkElement) {
        $budgetKurzrechner.on("submit", function (event) {
            event.preventDefault();
            var nettohaushaltseinkommen = getNettohaushaltseinkommen($nettohaushaltseinkommenInput);
            if (nettohaushaltseinkommen <= nettohaushaltseinkommenMinimum) {
                $ratenkreditLinkElement[0].click();
            }
            else {
                window.location.href = "/budgetrechner.html#?einkommen=".concat(nettohaushaltseinkommen, "&eigenkapital=0");
            }
        });
    }
    function createBudgetKurzrechnerConfiguration($budgetKurzrechner, $ratenkreditLinkElement, $finanzierungsvorschlaegeLinkElement, $nettohaushaltseinkommenInput) {
        return {
            budgetrechnerLinkUrlDefault: $budgetKurzrechner.attr("action"),
            ratenkreditLinkUrl: $ratenkreditLinkElement.attr("href"),
            finanzierungsvorschlaegeLinkUrl: $finanzierungsvorschlaegeLinkElement.attr("href"),
            nettohaushaltseinkommenDefault: getNettohaushaltseinkommen($nettohaushaltseinkommenInput),
            nettohaushaltseinkommenMaximum: parseInt($nettohaushaltseinkommenInput.attr("max"), 10),
        };
    }
    function initialize($budgetKurzrechner) {
        var $nettohaushaltseinkommenInput = $budgetKurzrechner.find("input[name=monatlichesNettohaushaltseinkommen]");
        var $ratenkreditLinkElement = $budgetKurzrechner.find(".budgetKurzrechner_ratenkredit .callToAction a");
        var $finanzierungsvorschlaegeLinkElement = $budgetKurzrechner.find(".budgetKurzrechner_finanzierungsvorschlaege .button");
        var budgetKurzrechnerConfiguration = createBudgetKurzrechnerConfiguration($budgetKurzrechner, $ratenkreditLinkElement, $finanzierungsvorschlaegeLinkElement, $nettohaushaltseinkommenInput);
        addSubmitHandler($budgetKurzrechner, $nettohaushaltseinkommenInput, $ratenkreditLinkElement);
        updateAngebotParameters($nettohaushaltseinkommenInput, $ratenkreditLinkElement, $finanzierungsvorschlaegeLinkElement, budgetKurzrechnerConfiguration);
        $nettohaushaltseinkommenInput.on("hypoport.formElement.blurFinished", function (event) {
            var nettohaushaltseinkommen = getNettohaushaltseinkommen($nettohaushaltseinkommenInput);
            updateBudget(nettohaushaltseinkommen, $nettohaushaltseinkommenInput);
            updateAngebotParameters($nettohaushaltseinkommenInput, $ratenkreditLinkElement, $finanzierungsvorschlaegeLinkElement, budgetKurzrechnerConfiguration);
            showRelevantResultSegment(nettohaushaltseinkommen, $budgetKurzrechner);
            event.stopPropagation();
        });
    }
    exports.initialize = initialize;
});
